<template>
    <div class="site-info">
        <div class="info-header" @click.self="changeState('isSiteInfoShow')">
            <div class="info-header-left">
                <span class="info-header-block"></span>
                <span class="info-header-text">站点信息</span>
                <span class="total-text">
                    ( 线路：<span @dblclick.stop="copyText($event)">{{ basicInfo.lineName || '--' }}</span> )
                </span>
            </div>
            <i :class="['el-icon', 'mgr-10', isSiteInfoShow ? 'el-icon-arrow-down' :'el-icon-arrow-right']"></i>
        </div>
        <div class="site-content" v-show="isSiteInfoShow">
            <div class="load-wrapper">
                <div class="load-wrapper-icon">
                    <span class="site-number">站点：{{ loadListNum }}个</span>
                </div>
                <el-table
                    :data="loadList"
                    border
                    class="load-list"
                    style="width: 100%"
                    max-height="210"
                    @cell-dblclick="cellDblClick"
                >
                    <el-table-column prop="num" label="序号" min-width="80px"></el-table-column>
                    <el-table-column
                        prop="siteAddress"
                        label="站点地址"
                        min-width="210px"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column prop="stationType" label="组织类型" min-width="120px"></el-table-column>
                    <el-table-column prop="count" label="单量" min-width="120px"></el-table-column>
                    <el-table-column prop="totalQty" label="总数量" min-width="120px"></el-table-column>
                    <el-table-column prop="totalWeight" label="总重量(kg)" min-width="120px"></el-table-column>
                    <el-table-column prop="totalVolume" label="总方量(m³)" min-width="150px"></el-table-column>
                    <el-table-column prop="pickingProgress" label="拣货进度" min-width="150px"></el-table-column>
                    <el-table-column
                        prop="arrivalRegistrationTypeName"
                        label="到车方式"
                        min-width="150px"
                    ></el-table-column>
                    <el-table-column prop="arrivalRegistrationTime" label="到车时间" min-width="150px"></el-table-column>
                    <el-table-column prop="arrivalRegistrationTime" label="到车照片" min-width="100px">
                        <template slot-scope="scope">
                            <div v-if="scope.row.arrivalAttachmentFlag" class="img-box">
                                <img src="@/assets/photos.png" @click.stop="showArrivalAttachment(scope.row)" @dblclick.stop="" style="width: 20px; cursor: pointer;">
                            </div>
                            <div v-else>--</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="ztbLoadDate" label="装车完成时间" min-width="150px"></el-table-column>
                    <el-table-column prop="loadUserName" label="装车操作人" min-width="150px">
                        <template slot-scope="scope">
                            <div>
                                {{ scope.row.loadUserName }}
                                {{ scope.row.loadingMethodName ? `(${scope.row.loadingMethodName})` : '' }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="arrivalRegistrationStatus"
                        label="到车标识"
                        min-width="140px"
                    ></el-table-column>
                    <el-table-column prop="makeArriveTime" label="预到车时间" min-width="140px"></el-table-column>
                    <el-table-column prop="pickupWaitingTime" label="提货等待时长(分)" min-width="140px"></el-table-column>
                    <el-table-column prop="departConfirmDate" label="发车确认时间" min-width="140px"></el-table-column>
                    <el-table-column prop="fenceArriveTime" label="围栏到车时间" min-width="140px"></el-table-column>
                    <el-table-column prop="fenceDepartTime" label="围栏发车时间" min-width="140px"></el-table-column>
                </el-table>
            </div>
            <div class="unload-wrapper">
                <div class="unload-wrapper-icon">
                    <span class="site-number">站点：{{ unloadListNum }}个</span>
                </div>
                <el-table
                    :data="unloadList"
                    border
                    class="unload-list"
                    style="width: 100%"
                    max-height="210"
                    @cell-dblclick="cellDblClick"
                >
                    <el-table-column prop="num" label="序号" min-width="80px"></el-table-column>
                    <el-table-column
                        prop="siteAddress"
                        label="站点地址"
                        min-width="210px"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column prop="stationType" label="组织类型" min-width="120px"></el-table-column>
                    <el-table-column prop="count" label="单量" min-width="120px"></el-table-column>
                    <el-table-column prop="totalQty" label="总数量" min-width="120px"></el-table-column>
                    <el-table-column prop="totalWeight" label="总重量(kg)" min-width="120px"></el-table-column>
                    <el-table-column prop="totalVolume" label="总方量(m³)" min-width="150px"></el-table-column>
                    <el-table-column prop="inTransitTime" label="在途时长(分)" min-width="150px"></el-table-column>
                    <el-table-column prop="arrivalConfirmTypeName" label="抵达方式" min-width="150px"></el-table-column>
                    <el-table-column prop="arrivalConfirmTime" label="抵达时间" min-width="150px"></el-table-column>
                    <el-table-column prop="arrivalStatus" label="抵达标识" min-width="140px"></el-table-column>
                    <el-table-column prop="fenceArrivalTime" label="围栏抵达时间" min-width="140px"></el-table-column>
                    <el-table-column prop="unloadingWaitingTime" label="卸货等待时长(分)" min-width="140px"></el-table-column>
                    <el-table-column prop="unloadingTime" label="卸货时间" min-width="140px"></el-table-column>
                </el-table>
            </div>
        </div>

        <!-- 附件 弹框 -->
        <attachment-dialog
            v-if="attachmentShow"
            :attachmentShow.sync="attachmentShow"
            :attachmentList="attachmentList"
            :isDeleteBtn="false">
        </attachment-dialog>
    </div>
</template>

<script>
import { copyToClip } from '../util';
import attachmentDialog from './imgDialog/Index';
import { queryArrivalAttachment } from '@/modules/transport/otp/api/performanceDispatchMgmtNew.js';
export default {
    name: 'SiteInformation',
    components: { attachmentDialog },
    props: {
        basicInfo: {
            type: Object,
            default () {
                return {};
            }
        },
        loadList: {
            type: Array,
            default () {
                return [];
            }
        },
        unloadList: {
            type: Array,
            default () {
                return [];
            }
        }
    },
    computed: {
        loadListNum () {
            return this.loadList.length || 0;
        },
        unloadListNum () {
            return this.unloadList.length || 0;
        }
    },
    data () {
        return {
            attachmentShow: false,
            attachmentList: [],
            isSiteInfoShow: true
        };
    },
    methods: {
        changeState (state) {
            this[state] = !this[state];
        },
        copyText (e) {
            const value = (e.target.innerHTML).trim();
            value !== '--' && copyToClip(value);
        },
        /**
         * @description 双击复制单元格信息
         */
        cellDblClick (row, column, cell, event) {
            if (row[column.property] === null || row[column.property] === undefined) return;
            const value = row[column.property];
            copyToClip(value);
        },
        /**
         * @description  查看到车登记附件
         */
        showArrivalAttachment (rowData) {
            if (rowData.arrivalAttachmentFlag && rowData.id) {
                const params = {
                    objId: rowData.id,
                    objType: 'ARRIVAL_REGISTER'
                };
                queryArrivalAttachment(params).then(res => {
                    if (res && +res.code === 0) {
                        this.attachmentList = res.data || [];
                        if (this.attachmentList.length) {
                            this.attachmentShow = true;
                        }
                    }
                }).catch(() => { });
            }
        }
    }
};
</script>

<style lang="less" scoped>
@import '../dispatchInfoDetail.less';
.site-info {
    background-color: #fff;
    margin-bottom: 14px;
    .total-text {
        font-size: 14px;
        color: #999;
        margin-left: 10px;
    }
}
.site-content {
    padding-bottom: 4px;
    // height: 340px;
    .load-wrapper {
        display: flex;
        margin: 10px 0px;
        .load-list {
            margin-right: 20px;
        }
        .img-box{
            display: flex;
            align-items: center;
        }
    }
    .unload-wrapper {
        display: flex;
        margin: 20px 0px 10px 0px;
        .unload-list {
            margin-right: 20px;
        }
    }
}
.load-wrapper-icon {
    width: 80px;
    height: 60px;
    background: url('../images/load.png') no-repeat center;
    background-size: 36px 48px;
    text-align: center;
}
.site-number {
    display: inline-block;
    margin-top: 60px;
    font-size: 12px;
}
.unload-wrapper-icon {
    width: 80px;
    height: 60px;
    background: url('../images/unload.png') no-repeat center;
    background-size: 36px 48px;
    text-align: center;
}
</style>
